// Restricted securities and buy list: the routes and the sidebar rows of `wealth.compliance.restricted-list` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.restricted-list',
    routes: [
        { frontend: 'desk', path: 'buy-list', lazy: () => import('@/pages/desk/buy-list/page') },
        {
            frontend: 'desk',
            path: 'restricted-list',
            lazy: () => import('@/pages/desk/restricted-list/page'),
        },
        {
            frontend: 'desk',
            path: 'buy-list-impact/:changeId',
            lazy: () => import('@/pages/desk/buy-list-impact/page'),
        },
    ],
});
